const NAME = 'flyout';

export const OPEN_IN = `${NAME}/OPEN_IN`;
export const CLOSE = `${NAME}/CLOSE`;
export const TOGGLE_CONFIRMATION = `${NAME}/TOGGLE_CONFIRMATION`;
